import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../utils/UtilsFormule";
import { TextField } from "@material-ui/core";
import ClientService from "../../services/PosService/ClientService";
import withLoader from "../../components/layouts/WithLoader";
import { Alert, Snackbar } from "@mui/material";

const ClientsVente = ({ startLoading, stopLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [availableClients, setAvailableClients] = useState([]);
  const [availableClient, setAvailableClient] = useState("");

  //**************alert
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  //**************filter
  const [onFilter, setOnFilter] = useState(false);
  const [typeToFilter, setTypeToFilter] = useState("");
  const [refToFilter, setRefToFilter] = useState("");
  const [nomToFilter, setNomToFilter] = useState("");
  const [prenomToFilter, setPrenomToFilter] = useState("");
  const [fullNameToFilter, setFullNameToFilter] = useState("");
  const [phoneToFilter, setPhoneToFilter] = useState("");

  useEffect(() => {
    if (!onFilter) {
      getAllClients();
    } else {
      onFilterClients();
    }
  }, [onFilter]);

  const getAllClients = () => {
    startLoading();
    ClientService.getAllClients(getCurrentUserId())
      .then((response) => {
        if (response?.data?.success) {
          setAvailableClients(response?.data?.success);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText(error.message || "An error occurred!");
        console.error("Error in getAllClients: ", error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onFilterClients = () => {
    let dataToFilter = [];
    if (refToFilter !== "") {
      dataToFilter = [refToFilter];
    } else if (fullNameToFilter !== "") {
      dataToFilter = [prenomToFilter, nomToFilter];
    } else if (phoneToFilter !== "") {
      dataToFilter = [phoneToFilter];
    }
    if (dataToFilter.length === 0) {
      setErrorAlertText("Vous devez choisir un élément de filter");
      setOpenErrorAlert(true);
      return;
    } else {
      const modelToFilter = {
        idUser: getCurrentUserId(),
        inputType: typeToFilter,
        inputValue: dataToFilter,
      };
      startLoading();
      ClientService.getClientsByFilter(modelToFilter)
        .then((response) => {
          if (response?.data?.success) {
            setAvailableClient(response.data.success);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("No clients found!");
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText(error.message || "An error occurred!");
          console.error("Error in filter clients : ", error);
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  const onClearFilter = () => {
    setOnFilter(false);
    setTypeToFilter("");
    setRefToFilter("");
    setFullNameToFilter("");
    setPrenomToFilter("");
    setNomToFilter("");
    setPhoneToFilter("");
    setAvailableClient("");
  };
  const onChangeRefFilterInfo = (event, type) => {
    if (event.target.value) {
      setRefToFilter(event.target.value);
      setTypeToFilter(type);
    } else {
      setRefToFilter("");
      setTypeToFilter("");
    }
  };
  const onChangeFullNameFilterInfo = (event, type) => {
    if (event.target.value) {
      setFullNameToFilter(event.target.value);
      const [prenom, nom] = event.target.value.trim().split(" ");
      setPrenomToFilter(prenom || "");
      setNomToFilter(nom || "");
      setTypeToFilter(type);
    } else {
      setFullNameToFilter("");
      setPrenomToFilter("");
      setNomToFilter("");
      setTypeToFilter("");
    }
  };

  const onChangePhoneFilterInfo = (event, type) => {
    if (event.target.value) {
      setPhoneToFilter(event.target.value);
      setTypeToFilter(type);
    } else {
      setPhoneToFilter("");
      setTypeToFilter("");
    }
  };

  const type_Backend = {
    reference: "ref",
    email: "email",
    nomPrenom: "name",
    tel: "phone",
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onVoirDetailsClient = (id) => {
    localStorage.setItem("idDetailsClientVente", id);
    window.open("/details-client-vente", "_blank");
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les Clients</h5>

                  {/* <button
                    class="btn btn-dark float-right"
                    // data-toggle="modal"
                    // data-target="#add-brand"
                    onClick={onAddShopHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button> */}
                </div>
              </div>

              <section className="content ">
                <div className="container-fluid">
                  <div className="row mb-2">
                    <div className="col-sm-12">
                      <div class="card card-dark">
                        <div class="card-body">
                          <div class="row">
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label htmlFor="inputName">Reference</label>
                                <TextField
                                  style={{
                                    width: "100%",
                                    backgroundColor:
                                      typeToFilter != "" &&
                                      typeToFilter !== type_Backend.reference
                                        ? "#BFBFBF"
                                        : "white",
                                  }}
                                  className="col-sm-12"
                                  variant="outlined"
                                  value={refToFilter}
                                  onChange={(e) =>
                                    onChangeRefFilterInfo(
                                      e,
                                      type_Backend?.reference
                                    )
                                  }
                                  id="datetime-local"
                                  type="text"
                                  // defaultValue="text"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  size="small"
                                  placeholder="reference...."
                                  disabled={
                                    typeToFilter != "" &&
                                    typeToFilter !== type_Backend.reference
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label htmlFor="inputName">Nom & Prenom</label>

                                <TextField
                                  style={{
                                    width: "100%",
                                    backgroundColor:
                                      typeToFilter != "" &&
                                      typeToFilter !== type_Backend.nomPrenom
                                        ? "#BFBFBF"
                                        : "white",
                                  }}
                                  className="col-sm-12"
                                  variant="outlined"
                                  value={fullNameToFilter}
                                  onChange={(e) =>
                                    onChangeFullNameFilterInfo(
                                      e,
                                      type_Backend?.nomPrenom
                                    )
                                  }
                                  id="datetime-local"
                                  type="text"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  size="small"
                                  placeholder="Nom & Prénom..."
                                  disabled={
                                    typeToFilter != "" &&
                                    typeToFilter !== type_Backend.nomPrenom
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label htmlFor="inputName">Telepone</label>

                                <TextField
                                  style={{
                                    width: "100%",
                                    backgroundColor:
                                      typeToFilter != "" &&
                                      typeToFilter !== type_Backend.phoneNumber
                                        ? "#BFBFBF"
                                        : "white",
                                  }}
                                  className="col-sm-12"
                                  variant="outlined"
                                  value={phoneToFilter}
                                  onChange={(e) =>
                                    onChangePhoneFilterInfo(
                                      e,
                                      type_Backend?.tel
                                    )
                                  }
                                  id="datetime-local"
                                  type="text"
                                  // defaultValue="text"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  size="small"
                                  placeholder="phone number...."
                                  disabled={
                                    typeToFilter != "" &&
                                    typeToFilter !== type_Backend.phoneNumber
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div className="col-sm-12  text-center">
                            <button
                              className="btn btn-dark"
                              onClick={() => {
                                onFilter && typeToFilter != ""
                                  ? onClearFilter()
                                  : setOnFilter(true);
                              }}
                            >
                              {onFilter && typeToFilter != ""
                                ? "Annuler le filter"
                                : "Valider le choix"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section class="content">
                <div class="card">
                  <div class="card-header  ">
                    <h3 class="card-title">Les Clients</h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <table class="table  projects">
                      <thead>
                        <tr>
                          <th>#REF</th>
                          <th>Prénom && Nom</th>
                          <th>Adresse</th>
                          <th>Numéro de téléphone</th>
                          <th>Adresse Email</th>
                          <th style={{ textAlign: "center" }}>
                            Nombre d'achats
                          </th>
                          <th style={{ textAlign: "center" }}>Montant Total</th>
                          <th style={{ textAlign: "center" }}>BD</th>
                          <th style={{ textAlign: "center" }}>Voir Plus</th>

                          {/* <th className="text-center" style={{ width: "12%" }}>
                            Modifier
                          </th>
                          <th className="text-center" style={{ width: "12%" }}>
                            Voir Plus
                          </th> */}
                          {/* <th className="text-center" style={{ width: "12%" }}>
                            Archiver
                          </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {onFilter && typeToFilter != "" ? (
                          <>
                            {
                              <tr>
                                <td>{availableClient?.ref || ""}</td>
                                <td>{availableClient?.name || ""}</td>
                                <td>{availableClient?.address || ""}</td>
                                <td>{availableClient?.phoneNumber || ""}</td>
                                <td>{availableClient?.email || ""}</td>
                                <td style={{ textAlign: "center" }}>
                                  {availableClient?.numberOfPurchases}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {availableClient?.spentMoney}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {availableClient?.birthDate
                                    ? UtilsFormule.formatDate(
                                        availableClient?.birthDate
                                      )
                                    : ""}
                                </td>
                              </tr>
                            }
                          </>
                        ) : (
                          <>
                            {availableClients?.length > 0 &&
                              availableClients?.map((element) => (
                                <tr key={element?.id}>
                                  <td>{element?.ref || ""}</td>
                                  <td>{element?.name || ""}</td>
                                  <td>{element?.address || ""}</td>
                                  <td>{element?.phoneNumber || ""}</td>
                                  <td>{element?.email || ""}</td>
                                  <td style={{ textAlign: "center" }}>
                                    {element?.numberOfPurchases}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {element?.spentMoney}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {element?.birthDate
                                      ? UtilsFormule.formatDate(
                                          element?.birthDate
                                        )
                                      : ""}
                                  </td>
                                  <td className="text-center">
                                    <button
                                      style={{ width: 40 }}
                                      class="btn btn-dark btn-sm"
                                      onClick={() =>
                                        onVoirDetailsClient(element.id)
                                      }
                                    >
                                      <i class="fas fa-eye"></i>
                                    </button>
                                  </td>
                                  {/* <td>
                                {UtilsFormule.formatDate(element.creationDate)}
                              </td> */}

                                  {/* <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-gray btn-sm "
                                  data-toggle="modal"
                                  data-target="#edit-brand"
                                  // onClick={() =>
                                  //   // onEditBrandHandler(
                                  //   //   element.id,
                                  //   //   element.name,
                                  //   //   element.description
                                  //   // )
                                  // }
                                >
                                  <i class="fas fa-pencil-alt"></i>
                                </button>
                              </td> */}

                                  {/* <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-black btn-sm "
                                  onClick={() =>
                                    onViewProductsHandler(
                                      element.id,
                                      element.name
                                    )
                                  }
                                >
                                  <i class="fas fa-shopping-cart"></i>
                                </button>
                              </td> */}
                                  {/* <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-danger btn-sm"
                                  onClick={() =>
                                    onArchiveHandler(element.id, 1)
                                  }
                                >
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td> */}
                                </tr>
                              ))}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ClientsVente);
